import { render, staticRenderFns } from "./AdSpot.vue?vue&type=template&id=5250dff4&"
import script from "./AdSpot.vue?vue&type=script&lang=js&"
export * from "./AdSpot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports